/**
 * @generated SignedSource<<fbeae3a5648c843fb651c0c086d404d7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type useEditorSpaceDetailFragment_content$data = Result<{
  readonly space: {
    readonly alias: string | null;
    readonly id: string | null;
    readonly key: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"SpaceDetail_space">;
  } | null;
  readonly " $fragmentType": "useEditorSpaceDetailFragment_content";
}, unknown>;
export type useEditorSpaceDetailFragment_content$key = {
  readonly " $data"?: useEditorSpaceDetailFragment_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"useEditorSpaceDetailFragment_content">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "catchTo": "RESULT"
  },
  "name": "useEditorSpaceDetailFragment_content",
  "selections": [
    {
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "kind": "ScalarField",
          "name": "alias"
        },
        {
          "kind": "FragmentSpread",
          "name": "SpaceDetail_space"
        }
      ]
    }
  ],
  "type": "Content"
};

(node as any).hash = "632abb3e0510c45725a5d3a2b20f17b9";

export default node;
